import { Link } from "react-router-dom";
import { useSettings } from "@/lib/useSettings";
import Icon from "@/components/Icon";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const abs = (u) => (!u ? "" : /^https?:\/\//i.test(u) ? u : u.startsWith("/") ? `${BACKEND_URL}${u}` : u);

export default function Footer() {
  const { settings } = useSettings();
  const s = settings || {};
  const year = new Date().getFullYear();
  const logo = s.logo_url;

  return (
    <footer className="bg-[#050B14] text-slate-200 pt-16 pb-8 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Brand + tagline */}
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            {logo ? (
              <div className="h-14 rounded-xl bg-[#00E5FF] shadow-[0_0_20px_rgba(0,229,255,0.35)] p-1.5 flex items-center justify-center">
                <img src={abs(logo)} alt={s.company_name_ar || "أمان"} className="h-full w-auto max-w-[120px] object-contain" data-testid="footer-logo-image" />
              </div>
            ) : (
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#00E5FF] to-[#00b8cc] flex items-center justify-center shadow-[0_0_20px_rgba(0,229,255,0.3)]">
                <Icon name="shield-check" className="text-[#0A1628]" size={22} strokeWidth={2.2} />
              </div>
            )}
            <div>
              <div className="font-heading text-2xl font-bold text-white">{s.company_name_ar || "أمان"}</div>
              <div className="text-cyan-300/80 text-xs uppercase tracking-[0.25em]">AMAN Security</div>
            </div>
          </div>
          <p className="mt-5 text-slate-400 max-w-md leading-relaxed">
            {s.tagline_ar}. حلول احترافية لكاميرات المراقبة، أنظمة الإنذار، إنذار الحريق،
            والشبكات في جميع أنحاء فلسطين.
          </p>
        </div>

        {/* Contact */}
        <div>
          <h4 className="font-heading text-white text-lg font-bold mb-4">تواصل معنا</h4>
          <ul className="space-y-3 text-sm">
            {s.phone && (
              <li>
                <a href={`tel:${s.phone}`} className="flex items-center gap-2 text-slate-300 hover:text-[#00E5FF] transition-colors" data-testid="footer-phone">
                  <Icon name="phone" size={16} />
                  <span dir="ltr">{s.phone}</span>
                </a>
              </li>
            )}
            {s.email && (
              <li>
                <a href={`mailto:${s.email}`} className="flex items-center gap-2 text-slate-300 hover:text-[#00E5FF] transition-colors" data-testid="footer-email">
                  <Icon name="mail" size={16} />
                  <span dir="ltr">{s.email}</span>
                </a>
              </li>
            )}
            {s.address_ar && (
              <li className="flex items-start gap-2 text-slate-300" data-testid="footer-address">
                <Icon name="map-pin" size={16} className="mt-1 shrink-0" />
                <span>{s.address_ar}</span>
              </li>
            )}
          </ul>
        </div>

        {/* Links */}
        <div>
          <h4 className="font-heading text-white text-lg font-bold mb-4">روابط سريعة</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-slate-300 hover:text-[#00E5FF] transition-colors">الرئيسية</Link></li>
            <li><Link to="/about" className="text-slate-300 hover:text-[#00E5FF] transition-colors">من نحن</Link></li>
            <li><Link to="/products" className="text-slate-300 hover:text-[#00E5FF] transition-colors">المنتجات</Link></li>
            <li><Link to="/offers" className="text-slate-300 hover:text-[#00E5FF] transition-colors">العروض</Link></li>
            <li><Link to="/contact" className="text-slate-300 hover:text-[#00E5FF] transition-colors">اتصل بنا</Link></li>
            <li><Link to="/services" className="text-slate-300 hover:text-[#00E5FF] transition-colors">الخدمات</Link></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-slate-500 text-xs">© {year} {s.company_name_ar || "أمان"}. جميع الحقوق محفوظة.</p>
        <p className="text-slate-500 text-xs">صُمم بحرفية لأمان أكبر — فلسطين 🇵🇸</p>
      </div>
    </footer>
  );
}
